module.exports = __webpack_public_path__ + "static/media/profile_wakatsukiren39572374d38b60916fddba9effd72a6d.webp";